import React, { useState, useEffect, useRef, useMemo } from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getProblemImages } from '../../../functions/get_problem';
import { formatProblemDisplay } from '../../../global/http_enum';
import './problem_view.css'

export default function ProblemView({ problem, event }) {
    // problem should be an array with the specific problem for this event
    // We should always receive exactly one problem that was specifically created for this event
    const theoryObject = Array.isArray(problem) && problem.length > 0
        ? problem[0]  // Use the specific problem passed for this event (should be only one)
        : null;
    const problemMappedTo = useMemo(() => theoryObject?.problem_mapped_to || [], [theoryObject?.problem_mapped_to]);
    const problemMappedToDisplay = problemMappedTo.join(', ') || '';
    const [problemImages, setProblemImages] = useState([]);
    const problemImagesSliderRef = useRef();

    // Get the domain type from event - check both eventType and domain properties
    const domain = event?.eventType || event?.domain || 'Theory';

    useEffect(() => {
        // Get problem images from problem mapped to
        if (problemMappedTo && problemMappedTo.length > 0 && domain) {
            const images = getProblemImages(problemMappedTo, domain);
            setProblemImages(images);
        } else {
            setProblemImages([]);
        }
    }, [problemMappedTo, domain]);

    const settingsSlick = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div id='problem-view'>
            <div className='problem-view-container'>
                <div className='problem-details-panel'>
                    <div className='detail-field'>
                        <label className='detail-label'>Event Name</label>
                        <div className='detail-value'>{event.name || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Negative Function Executed</label>
                        <div className='detail-value negative'>{event.negative_function_exluded || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Identified from Event</label>
                        <div className='detail-value negative'>{formatProblemDisplay(event.problem_identifyed_from_event) || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Principle Deficiency</label>
                        <div className='detail-value'>
                            {theoryObject?.pricipal_defeciency?.join(', ') || ''}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Mapped to</label>
                        <div className='detail-value'>{problemMappedToDisplay}</div>
                    </div>
                </div>

                {problemImages.length > 0 && (
                    <div className='problem-images-panel'>
                        <div className="images">
                            <h1 className='title'>Problem Mapped To</h1>
                            <Slider ref={problemImagesSliderRef} className='carasoul-box' {...settingsSlick}>
                                {problemImages.map((image, index) => (
                                    <div key={index} className="carousel-slide">
                                        <img alt={`Problem Mapped To ${index + 1}`} src={image} className="problem-image" />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
